module.exports = __webpack_public_path__ + "static/lato-v16-latin-regular-b8ee546acd6cc0c49f42ad3d48ef244f.woff";